import React from 'react'
import {Button, Col, Row} from "antd";
import CropTiming from "../CropTiming";
import {useTranslations} from "../../lang";
import {useAuth} from "../../auth";
import {useNavigate} from "react-router-dom";
import {formatCropMeasurement} from "../../utils/measurements";

export default function CropInfo({crop, disableEdit = false}) {

    const navigate = useNavigate()
    const {measurementSystem} = useAuth()
    const {translate} = useTranslations()

    const onClickEdit = () => {
        if(crop.is_fully_configured) {
            navigate(`/crops/${crop.id}`)
            return
        }

        navigate(`/crops?cropId=${crop.id}`)
    }

    return (
        <>
            <Row gutter={[18, 18]}>
                <Col md={2} xs={6}>
                    {crop.image && (
                        <img src={crop.image} style={{maxWidth: '100%', borderRadius: '15px'}} alt={crop.name}/>
                    )}
                </Col>
                <Col md={20} xs={24}>
                    <CropTiming crop={crop}/>
                </Col>
            </Row>
            <Row  className={"mar-t-1"}>
                <Col span={disableEdit ? 24 : 12}>
                    {crop.row_distance && crop.plant_distance && (
                        <p>
                            {translate('Plantafstand')}: {formatCropMeasurement(crop, 'row_distance', measurementSystem)} x {formatCropMeasurement(crop, 'plant_distance', measurementSystem)}
                        </p>
                    )}
                    {crop.sowing_depth && (
                        <p>
                            {translate('Zaaidiepte')}: {formatCropMeasurement(crop, 'sowing_depth', measurementSystem)}
                        </p>
                    )}
                </Col>
                {!disableEdit && (
                    <Col span={12} className={"text-right"}>
                        <Button href={crop.url} target={"_blank"} className={"mar-b-1 mar-r-1"}>{translate('Naar website')}</Button>
                        <Button className={"mar-b-1"} onClick={onClickEdit}>Gewas bewerken</Button>
                    </Col>
                )}

            </Row>
        </>
    )
}